import { queryKey } from 'Shared/const/queryKey';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { type GetViewupAccountsRes, ViewingPlatform } from 'app/_entities/sns-account';
import type { ViewingCommonQueryKey } from 'app/viewing/_entities/common/api/queries';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';

export const useGetActiveNBlogAccount = (
  params?: QueryParam<
    GetViewupAccountsRes,
    unknown,
    GetViewupAccountsRes[number] | null,
    ViewingCommonQueryKey['accounts']['queryKey']
  >,
) => {
  const { accessToken } = useTokenStore();
  const queryResult = useSDQuery<
    GetViewupAccountsRes,
    unknown,
    GetViewupAccountsRes[number] | null,
    ViewingCommonQueryKey['accounts']['queryKey']
  >({
    ...params?.options,
    enabled: !!accessToken,
    ...queryKey.viewingCommon.accounts,
    gcTime: 3000,
    select: (data) => formatAccount(data),
    staleTime: 3000,
  });

  return queryResult;
};

const formatAccount = (accounts: GetViewupAccountsRes): GetViewupAccountsRes[number] | null => {
  const account = accounts?.find(
    ({ viewingPlatform: platformCategory, isActive }) =>
      (platformCategory as string) === ViewingPlatform.NBLOG && isActive,
  );
  if (!account) return null;
  return account;
};
